import { css } from "@emotion/react"
import FancyDatePicker from "../_control/FancyDatePicker"
import NewAnalysisDateTimePicker from "../analysis/NewAnalysisDateTimePicker"
import { useIntl } from "react-intl"

export default function DateTimeRangePicker({ startDate, setStartDate, endDate, setEndDate, showTimePicker = true, ...props }) {
    const { formatMessage } = useIntl()
    // creates browser local date obj
    return <div css={css`display: flex; gap: 3em; flex-wrap: wrap;`}>
        <div css={css`display: grid; gap: 1em;`}>
            <span>

                {formatMessage({ id: 'startDate' })}
            </span>
            <div css={css`display: flex; gap: 1em;`}>
                <FancyDatePicker date={startDate} onDateChange={(date) => { setStartDate(date) }} css={css`min-width: 15em;`} />
                <NewAnalysisDateTimePicker
                    formDate={startDate}
                    setFormDate={setStartDate}
                    css={css`
                        ${showTimePicker ? '' : 'display: none;'}
                    `}
                />
            </div>
        </div>

        <div css={css`display: grid; gap: 1em;`}>
            <span>
                {formatMessage({ id: 'endDate' })}
            </span>
            <div css={css`display: flex; gap: 1em;`}>
                <FancyDatePicker date={endDate} onDateChange={(date) => { setEndDate(date) }} css={css`min-width: 15em;`} />
                <NewAnalysisDateTimePicker
                    formDate={endDate}
                    setFormDate={setEndDate}
                    css={css`
                        ${showTimePicker ? '' : 'display: none;'}
                    `}
                />
            </div>
        </div>
    </div>
}